import _asyncToGenerator from "/Users/beixinyuan/Documents/www/newParty1/party-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.array.concat.js";
import Head from "@/components/Head/index.vue";
import Upload from "@/components/UpLoadFile/index.vue";
import useCurrentInstance from "@/hooks/useCurrentInstance";
import { defineComponent, onMounted, reactive, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from "element-plus";
import 'element-plus/es/components/message/style/index'
import 'element-plus/es/components/message-box/style/index'

import UpLoadImg from "@/components/UpLoadImg/index.vue";
import previewImg from "@/components/previewImg/index.vue";
export default defineComponent({
  components: {
    Head: Head,
    Upload: Upload,
    UpLoadImg: UpLoadImg,
    previewImg: previewImg
  },
  setup: function setup() {
    var route = useRoute();
    var router = useRouter();

    var _useCurrentInstance = useCurrentInstance(),
        globalProperties = _useCurrentInstance.globalProperties;

    var id = route.query.id;
    var baseurl = process.env.VUE_APP_BASE_URL; // 详情信息

    var Data = reactive({
      detail: {},
      cardList: [{
        imgPlus: ''
      }],
      form: {
        comment: '',
        cardUrls: "",
        wishId: 0
      },
      show: true
    }); //图片

    function Imgchange(val) {
      Data.form.cardUrls = val.join(',');
    } // 详情回显


    function getDetail(_x) {
      return _getDetail.apply(this, arguments);
    } // 根据id获取打卡数据


    function _getDetail() {
      _getDetail = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(id) {
        var _yield$globalProperti, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getWishDetailsById"]({
                  id: id
                });

              case 2:
                _yield$globalProperti = _context.sent;
                data = _yield$globalProperti.data;
                Object.assign(Data.detail, data);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return _getDetail.apply(this, arguments);
    }

    function getWishClockCardList(_x2) {
      return _getWishClockCardList.apply(this, arguments);
    }

    function _getWishClockCardList() {
      _getWishClockCardList = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
        var _yield$globalProperti2, data, code;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getWishClockCardList"]({
                  id: id
                });

              case 2:
                _yield$globalProperti2 = _context2.sent;
                data = _yield$globalProperti2.data;
                code = _yield$globalProperti2.code;

                if (code == 0) {
                  Data.cardList = data;
                  data.forEach(function (item, index) {
                    //   Data.cardList[index].img = [];
                    Data.cardList[index].imgPlus = '';

                    if (item.cardUrls != '') {
                      var arr = item.cardUrls.split(',');
                      arr.forEach(function (item1) {
                        //   Data.cardList[index].img.push(this.$urls + imgToThn(item1));
                        Data.cardList[index].imgPlus.concat(baseurl + item1);
                      });
                    }
                  });
                }

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));
      return _getWishClockCardList.apply(this, arguments);
    }

    onMounted(function () {
      // 详情
      getDetail(id);
      getWishClockCardList(id);
    });
    watch(function () {
      return Data.form.comment;
    }, // 注意这里
    function (val) {
      if (val == '') {
        Data.show = true;
      }
    }, {
      deep: true,
      immediate: true // 立即执行

    });

    function operation(_x3) {
      return _operation.apply(this, arguments);
    }

    function _operation() {
      _operation = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(id) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                Data.form.wishId = id; //TODO可优化进行提示

                ElMessageBox.confirm("确定要打卡?", "温馨提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
                  var _yield$globalProperti3, code, msg;

                  return regeneratorRuntime.wrap(function _callee3$(_context3) {
                    while (1) {
                      switch (_context3.prev = _context3.next) {
                        case 0:
                          _context3.next = 2;
                          return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["getWishClock"](Data.form);

                        case 2:
                          _yield$globalProperti3 = _context3.sent;
                          code = _yield$globalProperti3.code;
                          msg = _yield$globalProperti3.msg;

                          if (code == 0) {
                            ElMessage.success("打卡成功");
                            router.back();
                          } else {
                            ElMessage.error(msg);
                          }

                        case 6:
                        case "end":
                          return _context3.stop();
                      }
                    }
                  }, _callee3);
                }))).catch(function () {//console.log(111);
                });

              case 2:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      return _operation.apply(this, arguments);
    }

    function finish(_x4) {
      return _finish.apply(this, arguments);
    }

    function _finish() {
      _finish = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(id) {
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(Data.cardList.length == 0)) {
                  _context6.next = 3;
                  break;
                }

                ElMessage.warning("请先打卡");
                return _context6.abrupt("return");

              case 3:
                ElMessageBox.confirm("确定要完成吗?", "温馨提示", {
                  confirmButtonText: "确定",
                  cancelButtonText: "取消",
                  type: "warning"
                }).then( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
                  var _yield$globalProperti4, code, msg;

                  return regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.next = 2;
                          return globalProperties === null || globalProperties === void 0 ? void 0 : globalProperties.$api["finishWish"](id);

                        case 2:
                          _yield$globalProperti4 = _context5.sent;
                          code = _yield$globalProperti4.code;
                          msg = _yield$globalProperti4.msg;

                          if (code == 0) {
                            ElMessage.success("操作成功");
                            getDetail(id);
                          } else {
                            ElMessage.error(msg);
                          }

                        case 6:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5);
                }))).catch(function () {//console.log(111);
                });

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));
      return _finish.apply(this, arguments);
    }

    return {
      Data: Data,
      baseurl: baseurl,
      operation: operation,
      getDetail: getDetail,
      finish: finish,
      getWishClockCardList: getWishClockCardList,
      Imgchange: Imgchange
    };
  }
});